import { CareerEventStep, Character } from "../common/character";
import { Attribute } from "../helpers/attributes";
import { Department } from "../helpers/department";
import { StepContext, modifyCharacterAttribute, modifyCharacterDiscipline } from "../state/characterActions";
import store from "../state/store";
import { IAttributeController } from "./attributeController";
import { IDisciplineController } from "./disciplineListComponent";

export class CareerEventDisciplineController implements IDisciplineController {

    readonly character: Character;
    readonly careerEventStep: CareerEventStep;
    readonly context: StepContext;
    readonly disciplines: Department[];

    constructor(character: Character, careerEventStep: CareerEventStep, context: StepContext, disciplines: Department[]) {
        this.character = character;
        this.disciplines = disciplines;
        this.context = context;
        this.careerEventStep = careerEventStep;
    }

    isShown(discipline: Department) {
        return this.disciplines.indexOf(discipline) >= 0;
    }
    isEditable(discipline: Department): boolean {
        return true;
    }
    getValue(discipline: Department): number {
        return this.character.departments[discipline];
    }
    canIncrease(discipline: Department): boolean {
        return this.getValue(discipline) < Character.maxDepartment(this.character) &&
            (this.getValue(discipline) < (Character.maxDepartment(this.character) - 1) || !this.character.hasMaxedDepartment())
            && this.careerEventStep.discipline == null;
    }
    canDecrease(discipline: Department): boolean {
        return this.careerEventStep?.discipline === discipline;
    }
    onIncrease(discipline: Department): void {
        store.dispatch(modifyCharacterDiscipline(discipline, this.context, true));
    }
    onDecrease(discipline: Department): void {
        store.dispatch(modifyCharacterDiscipline(discipline, this.context, false));
    }
}

export class CareerEventAttributeController implements IAttributeController {

    readonly character: Character;
    readonly careerEventStep: CareerEventStep;
    readonly context: StepContext;
    readonly attributes: Attribute[];

    constructor(character: Character, careerEventStep: CareerEventStep, context: StepContext, attributes: Attribute[]) {
        this.character = character;
        this.attributes = attributes;
        this.context = context;
        this.careerEventStep = careerEventStep;
    }

    isShown(attribute: Attribute) {
        return this.attributes.indexOf(attribute) >= 0;
    }
    isEditable(attribute: Attribute): boolean {
        return true;
    }
    getValue(attribute: Attribute): number {
        return this.character.attributes[attribute];
    }
    getDeltaValue(attribute: Attribute): number|undefined {
        return undefined;
    }
    canIncrease(attribute: Attribute): boolean {
        return this.getValue(attribute) < Character.maxAttribute(this.character) &&
            (this.getValue(attribute) < (Character.maxAttribute(this.character) - 1) || !this.character.hasMaxedAttribute())
            && this.careerEventStep.attribute == null;
    }
    canDecrease(attribute: Attribute): boolean {
        return this.careerEventStep?.attribute === attribute;
    }
    onIncrease(attribute: Attribute): void {
        store.dispatch(modifyCharacterAttribute(attribute, this.context, true));
    }
    onDecrease(attribute: Attribute): void {
        store.dispatch(modifyCharacterAttribute(attribute, this.context, false));
    }
    get instructions() {
        return []
    }
}

